/**
 * Format integer teňňe (1 manat = 100 teňňe) using locale-appropriate grouping.
 *
 * No `float` math in business logic — `tenne / 100` only appears inside the
 * formatter, never in calculation paths.
 */

export function formatTenne(tenne: number, locale = "tk-TM"): string {
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(tenne / 100);
}

export function formatTenneCurrency(tenne: number, locale = "tk-TM"): string {
  // TM Manat doesn't have a unicode currency symbol in many locale data sets;
  // append the ISO code explicitly so output is consistent.
  return `${formatTenne(tenne, locale)} TMT`;
}

/** Parse an operator-typed decimal: accept both `.` and `,` as separators. */
export function parseDecimalInput(raw: string): string | null {
  const trimmed = raw.trim().replace(/\s+/g, "").replace(",", ".");
  if (!trimmed) return null;
  if (!/^-?\d+(\.\d+)?$/.test(trimmed)) return null;
  return trimmed;
}
